// 현재 언어 (예: 'ko', 'en', 'zh')
const currentLang = localStorage.getItem('i18nextLng') || 'ko';

const baseFonts = 'LINESeedKR, sans-serif, Noto Sans CJK KR';

// 언어별 폰트 우선순위 조정
const getFontFamily = () => {
  if (currentLang.startsWith('zh')) {
    // 중국어일 때: Noto Sans CJK KR을 제일 앞으로
    return 'Noto Sans CJK KR, LINESeedKR, sans-serif';
  }
  return baseFonts;
};

export type Colors = {
    primary: string;
    primaryHover: string;
    secondary: string;
    secondaryHover: string;
    background: string;
    textPrimary: string;
    textPrimaryHover: string;
    textSecondary: string;
    error: string;
    success: string;
    warning: string;
    buttonCancel20: string;
    textCancel: string;
    colorWarn: string;
    BIBI: string;
    BIBI_Dart: string;
    DefaultTextColor: string;
  };
  
  export type Typography = {
    big: string;   // 큰 폰트 크기
    normal: string; // 기본 폰트 크기
    small: string;  // 작은 폰트 크기
    fontFamily: string; // 폰트 패밀리
  };
  
  export interface Theme {
    colors: Colors;
    typography: Typography;
  }
  
  const theme: Theme = {
    colors: {
      primary: '#3498db',       // 주요 색상
      primaryHover: '#2980b9',  // 주요 색상 (hover)
      secondary: '#2ecc71',     // 보조 색상
      secondaryHover: '#27ae60',// 보조 색상 (hover)
      background: '#f4f6f7',    // 배경 색상
      textPrimary: '#333333',   // 텍스트 색상 (기본)
      textPrimaryHover: '#666666',
      textSecondary: '#95a5a6', // 텍스트 색상 (보조)
      error: '#e74c3c',         // 오류 색상
      success: '#27ae60',       // 성공 색상
      warning: '#f39c12',       // 경고 색상
      buttonCancel20: '#6c757d33',
      textCancel: '#6C757D', 
      colorWarn: '#c03221',
      BIBI: '#14B446',
      BIBI_Dart: '#003C1E',
      DefaultTextColor: '#232D42',
    },
    typography: {
      big: '24px',   // 큰 텍스트 크기
      normal: '18px', // 기본 텍스트 크기
      small: '14px',  // 작은 텍스트 크기
      fontFamily: getFontFamily(),
    },
  };
  
  export default theme;